var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBraavosLogoLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#0D0C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07636 3.62094C8.08745 3.64017 8.07272 3.6639 8.05085 3.6639C7.60834 3.6639 7.24863 4.02248 7.24018 4.46806C7.08866 4.43911 6.93165 4.43693 6.77655 4.46368C6.76584 4.02013 6.40704 3.6639 5.96598 3.6639C5.94409 3.6639 5.92935 3.64016 5.94045 3.62091C6.15464 3.24955 6.55271 3 7.0084 3C7.4641 3 7.86218 3.24956 8.07636 3.62094Z",
    fill: "#FF9A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43658 6.39206C9.56467 6.43176 9.68582 6.31695 9.64083 6.18834C9.23775 5.03613 7.96504 4.56537 7.00234 4.56537C6.03794 4.56537 4.73686 5.05118 4.36313 6.19432C4.32137 6.32207 4.44217 6.43305 4.56836 6.39348L6.90443 5.66082C6.96044 5.64325 7.02032 5.64315 7.07639 5.66053L9.43658 6.39206Z",
    fill: "#FF9A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35787 6.59139L6.90625 5.80033C6.96193 5.78305 7.02138 5.783 7.07708 5.8002L9.64139 6.59178C9.8543 6.6575 10 6.85824 10 7.08585V9.45722C9.99013 10.0361 9.48208 10.5 8.91673 10.5H7.97771C7.88489 10.5 7.80972 10.4232 7.80972 10.3281V9.49672C7.80972 9.16934 7.99902 8.87302 8.29196 8.74187C8.68463 8.56607 9.14917 8.32828 9.23655 7.85109C9.26475 7.69707 9.16662 7.54851 9.01653 7.51797C8.637 7.44076 8.21625 7.47058 7.86045 7.63346C7.45652 7.81838 7.35086 8.12596 7.31174 8.53905L7.26433 8.98407C7.24984 9.12008 7.12526 9.22427 6.99164 9.22427C6.85342 9.22427 6.74978 9.11653 6.73479 8.97582L6.68826 8.53905C6.65475 8.18522 6.59401 7.84151 6.23663 7.6779C5.82897 7.49128 5.41929 7.42931 4.98347 7.51797C4.83338 7.54851 4.73525 7.69707 4.76345 7.85109C4.85159 8.33243 5.31248 8.56478 5.70804 8.74187C6.00098 8.87302 6.19028 9.16934 6.19028 9.49672V10.328C6.19028 10.423 6.11514 10.5 6.02232 10.5H5.08327C4.51792 10.5 4.00987 10.0361 4 9.45722V7.08523C4 6.85791 4.14533 6.65736 4.35787 6.59139Z",
    fill: "#FF9A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraavosLogoLeaderboard);
export default __webpack_public_path__ + "static/media/braavos_logo_leaderboard.286c2b11ed4d61b088dd465393aa4a98.svg";
export { ForwardRef as ReactComponent };